<tbody class="bg-white text-center py-14">
<tr>
  <td colspan="10">
    <div class="py-14">
      <app-no-data class="" [message]="message() ?? 'No data found'"></app-no-data>
    </div>
  </td>
</tr>
</tbody>
